import { useOperatorContext } from "@src/context/operatorContext";
import { useAuthContext } from "@src/context";
import { InactiveOperatorModal } from "@src/components/atoms";

const InactiveAccountWrapper = () => {
  const auth = useAuthContext();
  const { profile } = useOperatorContext();

  if (!profile?.customer?.contractEndDate) return null;

  const contractEndDate = new Date(profile.customer.contractEndDate).getTime();
  const now = new Date().getTime();
  const inactiveAccount = now > contractEndDate;

  const onReturnToLogin = () => {
    auth.logout();
  };

  return (
    <>
      {inactiveAccount && (
        <InactiveOperatorModal onConfirmAction={onReturnToLogin} />
      )}
    </>
  );
};
export default InactiveAccountWrapper;
